/* Native disclosure interaction adapted from sd-header-mega.js, scoped to FELKIS. */
(()=>{
/* FK_MOUSE_DRAG_START */
 const enableMouseDrag=track=>{
  if(track.dataset.fkMouseDragReady)return;track.dataset.fkMouseDragReady='true';
  let startX=0,startY=0,startScroll=0,dragging=false,active=false,suppressClick=false;
  const finish=event=>{
   if(!active)return;active=false;
   if(track.hasPointerCapture?.(event.pointerId))track.releasePointerCapture(event.pointerId);
   if(dragging){suppressClick=true;setTimeout(()=>{suppressClick=false;},0);}
   track.classList.remove('fk-mouse-dragging');dragging=false;
  };
  track.querySelectorAll('img').forEach(image=>{image.draggable=false;});
  track.addEventListener('dragstart',event=>event.preventDefault());
  track.addEventListener('click',event=>{if(!suppressClick)return;event.preventDefault();event.stopImmediatePropagation();suppressClick=false;},true);
  track.addEventListener('pointerdown',event=>{
   if(event.pointerType!=='mouse'||event.button!==0||event.target.closest('button,input,select,textarea,[contenteditable="true"]'))return;
   active=true;dragging=false;startX=event.clientX;startY=event.clientY;startScroll=track.scrollLeft;
  });
  track.addEventListener('pointermove',event=>{
   if(!active)return;
   const delta=event.clientX-startX;
   if(!dragging){if(Math.abs(delta)<5||Math.abs(delta)<Math.abs(event.clientY-startY))return;dragging=true;track.classList.add('fk-mouse-dragging');track.setPointerCapture?.(event.pointerId);}
   event.preventDefault();track.scrollLeft=startScroll-delta;
  });
  track.addEventListener('pointerup',finish);
  track.addEventListener('pointercancel',finish);
  track.addEventListener('lostpointercapture',event=>{if(active)finish(event);});
 };
 /* FK_MOUSE_DRAG_END */
 const initialize=(scope=document)=>{
  scope.querySelectorAll('.murlto-rail__track,slider-component .slider,slideshow-component .slideshow').forEach(enableMouseDrag);
  scope.querySelectorAll('[data-fk-header]').forEach(header=>{
   if(header.dataset.ready)return;header.dataset.ready='true';
   const disclosures=[...header.querySelectorAll('details')];
   disclosures.forEach(d=>{
    const summary=d.querySelector(':scope > summary');
    const update=()=>{summary.setAttribute('aria-expanded',String(d.open));if(d.hasAttribute('data-fk-mobile'))summary.setAttribute('aria-label',d.open?'メニューを閉じる':'メニューを開く');};
    d.addEventListener('toggle',update);update();
    summary.addEventListener('keydown',e=>{if(e.key==='ArrowDown'){e.preventDefault();d.open=true;d.querySelector('a')?.focus();}});
   });
   const close=()=>disclosures.reverse().forEach(d=>d.open=false);
   document.addEventListener('pointerdown',e=>{if(!header.contains(e.target))close();});
   document.addEventListener('keydown',e=>{if(e.key==='Escape'){const open=header.querySelector('details[open]');if(open){e.preventDefault();close();open.querySelector('summary')?.focus();}}});
   header.addEventListener('click',e=>{if(e.target.closest('a'))close();});
   header.addEventListener('focusout',()=>{setTimeout(()=>{if(!header.contains(document.activeElement))close();},0);});
  });
  scope.querySelectorAll('.murlto-rail__track').forEach(track=>{
   if(track.dataset.keyboardReady)return;track.dataset.keyboardReady='true';
   track.addEventListener('keydown',e=>{if(e.target!==track||!['ArrowLeft','ArrowRight'].includes(e.key))return;e.preventDefault();const root=track.closest('.fk-rail');root.querySelector(e.key==='ArrowRight'?'[data-rail-next]':'[data-rail-prev]').click();});
  });
 };
 initialize();document.addEventListener('shopify:section:load',()=>initialize());
})();
